export default "__VITE_ASSET__BHbcRoMo__"